import { render, staticRenderFns } from "./RelationshipWithSunTemplate.vue?vue&type=template&id=50469fde&scoped=true"
import script from "./RelationshipWithSunTemplate.vue?vue&type=script&lang=js"
export * from "./RelationshipWithSunTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50469fde",
  null
  
)

export default component.exports